import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Button } from "react-bootstrap";


import { Error } from '../helpers/Error'
import { SpinnerGif } from '../helpers/SpinnerGif';
import './Imagenes.css'
import { globalContext } from '../Context/GlobalContext';
import { useTranslation } from 'react-i18next';

const apiProductos = process.env.REACT_APP_API_PRODUCTOS

const Highlighters = () => {

    const [number, setNumber] = useState();
    const [current, setCurrent] = useState(0);
    const navigate = useNavigate();
    const { colorTheme } = useContext(globalContext)

    const [t] = useTranslation("global")

    useEffect(() => {
        obtenerDatos()
    }, []);

    const obtenerDatos = async () => {
        try {
            await axios(`${apiProductos}/ofertas?limit=5&offset=0`)
                .then(res => { console.log(res); setNumber(res.data.articulos) })
                .catch(err => { console.log(err); })
        }
        catch (error) {
            console.log(error.message);
        }
    };

    let img = process.env.PUBLIC_URL + "/assets/sinimagen.gif";

    if (number === undefined) return <Error />

    if (!number) return <SpinnerGif text={'Cargando'} />

    const total = number.length;
    const itemsPerSlide = 4;
    const totalSlides = Math.ceil(total / itemsPerSlide);
    const currentSlide = Math.floor(current / itemsPerSlide);
    const goPrev = () => setCurrent((prev) => (prev - itemsPerSlide < 0 ? (totalSlides - 1) * itemsPerSlide : prev - itemsPerSlide));
    const goNext = () => setCurrent((prev) => (prev + itemsPerSlide >= total ? 0 : prev + itemsPerSlide));
    const slideItems = number.slice(currentSlide * itemsPerSlide, currentSlide * itemsPerSlide + itemsPerSlide);

    return (
        <div id="divDestacados" className={`bg-transparent text-${colorTheme === 'dark' ? 'light' : 'dark'} animated-title`}
            style={{ position: 'relative', maxWidth: 1400, margin: '0 auto', padding: 24 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 24 }}>{t("home.productos-destacados")}</h2>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button onClick={goPrev} style={{ background: 'none', border: 'none', fontSize: 40, cursor: 'pointer', color: '#888', padding: 0, marginRight: 16, lineHeight: 1 }}>&lt;</button>
                <div style={{ display: 'flex', gap: 36, justifyContent: 'center', width: '100%' }}>
                    {slideItems.map((item, idx) => (
                        <div className={"renderItem text-dark animated-title"}
                            key={item.Alias}
                            style={{
                                minWidth: 270,
                                maxWidth: 320,
                                background: colorTheme === 'dark' ? '#23272b' : '#fff',
                                borderRadius: 20,
                                boxShadow: '0 4px 18px 0 rgba(0,0,0,0.10)',
                                padding: 28,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                border: '1px solid #e0e0e0',
                                transition: 'box-shadow 0.2s',
                                animationDelay: `${idx * 0.12 + 0.1}s`,
                            }}>
                            <LazyLoadImage
                                src={item.Imagenes ? process.env.PUBLIC_URL + `/articulos/${encodeURIComponent(item.Imagenes?.split(',')[0])}` : img}
                                alt={'solution box'}
                                style={{
                                    width: '100%',
                                    maxWidth: 180,
                                    maxHeight: 140,
                                    minHeight: 80,
                                    objectFit: 'contain',
                                    borderRadius: 10,
                                    marginBottom: 18,
                                    background: '#f8f8f8',
                                    boxShadow: '0 1px 6px 0 rgba(0,0,0,0.08)',
                                    display: 'block',
                                }}
                            />
                            <div className='renderItemCenter' style={{ textAlign: 'center', marginBottom: 14 }}>
                                <div style={{
                                    fontWeight: 700,
                                    fontSize: 20,
                                    maxWidth: 220,
                                    margin: '0 auto',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    minHeight: 48,
                                }}>{item.Nombre}</div>
                                <div style={{
                                    color: '#666',
                                    fontSize: 16,
                                    maxWidth: 220,
                                    margin: '0 auto',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    minHeight: 40,
                                }}>{item.Marca}</div>
                            </div>
                            <Button variant="dark" className="btnItem" style={{ marginTop: 10, width: '100%', fontSize: 16, padding: '10px 0' }} onClick={() => navigate(`/detalle?sku=${item.Alias}`)}>{t("home.me-interesa")}</Button>
                        </div>
                    ))}
                </div>
                <button onClick={goNext} style={{ background: 'none', border: 'none', fontSize: 40, cursor: 'pointer', color: '#888', padding: 0, marginLeft: 16, lineHeight: 1 }}>&gt;</button>
            </div>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
                {Array.from({ length: totalSlides }).map((_, idx) => (
                    <span key={idx} style={{
                        display: 'inline-block',
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        background: idx === currentSlide ? '#333' : '#bbb',
                        margin: '0 4px',
                        transition: 'background 0.2s'
                    }} />
                ))}
            </div>
        </div>
    )
}
export default Highlighters;
